import { formItemClasses } from '../../FormItem';
import { randomStr } from '../../Shared';
const componentName = 'TextField';
const classPrefix = `ui-${componentName}`;
export const textFieldClasses = {
    root: `${classPrefix}-root-${randomStr()}`,
};
export function getStyle() {
    const style = {
        [`&.${textFieldClasses.root}.${formItemClasses.root} .${formItemClasses.item.root}`]: {
            marginBottom: 0,
        },
    };
    return style;
}
